export enum ChargeType {
  PHONE_NUMBER_PURCHASE = "PHONE_NUMBER_PURCHASE",
  PHONE_NUMBER_MONTHLY = "PHONE_NUMBER_MONTHLY",
  PHONE_NUMBER_RELEASE = "PHONE_NUMBER_RELEASE",
  CALL_MINUTE = "CALL_MINUTE",
  SMS = "SMS",
  AUTO_TOPUP_FEE = "AUTO_TOPUP_FEE",
  AI_AGENT_MINUTE = "AI_AGENT_MINUTE",
  LINE_TYPE_LOOKUP = "LINE_TYPE_LOOKUP",
  CALLER_ID_LOOKUP = "CALLER_ID_LOOKUP",
  DNC_SCRUB = "DNC_SCRUB",
  SKIP_TRACE = "SKIP_TRACE",
  PROPERTY_DATA_OVERAGE = "PROPERTY_DATA_OVERAGE",
  TWO_FACTOR_SMS = "TWO_FACTOR_SMS",
  TWO_FACTOR_VERIFICATION = "TWO_FACTOR_VERIFICATION",
  MACHINE_DETECTION = "MACHINE_DETECTION",
  A2P_BRAND_REGISTRATION = "A2P_BRAND_REGISTRATION",
  A2P_CAMPAIGN_VETTING = "A2P_CAMPAIGN_VETTING",
  A2P_ASSISTED_REGISTRATION = "A2P_ASSISTED_REGISTRATION",
  RECORDING_STORAGE = "RECORDING_STORAGE",
  TRANSCRIPTION = "TRANSCRIPTION",
}

export const CHARGE_TYPE_LABELS: Record<ChargeType, string> = {
  [ChargeType.PHONE_NUMBER_PURCHASE]: "Phone number",
  [ChargeType.PHONE_NUMBER_MONTHLY]: "Phone number monthly fee",
  [ChargeType.PHONE_NUMBER_RELEASE]: "Number release",
  [ChargeType.CALL_MINUTE]: "Call",
  [ChargeType.SMS]: "Text message",
  [ChargeType.AUTO_TOPUP_FEE]: "Auto top-up fee",
  [ChargeType.AI_AGENT_MINUTE]: "AI agent call",
  [ChargeType.LINE_TYPE_LOOKUP]: "Line type lookup",
  [ChargeType.CALLER_ID_LOOKUP]: "Caller ID lookup",
  [ChargeType.DNC_SCRUB]: "Do Not Call check",
  [ChargeType.SKIP_TRACE]: "Skip trace",
  [ChargeType.PROPERTY_DATA_OVERAGE]: "Property data overage",
  [ChargeType.TWO_FACTOR_SMS]: "Two-factor code",
  [ChargeType.TWO_FACTOR_VERIFICATION]: "Two-factor verification",
  [ChargeType.MACHINE_DETECTION]: "Voicemail detection",
  [ChargeType.A2P_BRAND_REGISTRATION]: "Texting brand registration",
  [ChargeType.A2P_CAMPAIGN_VETTING]: "Texting campaign vetting",
  [ChargeType.A2P_ASSISTED_REGISTRATION]: "Assisted texting registration",
  [ChargeType.RECORDING_STORAGE]: "Recording storage",
  [ChargeType.TRANSCRIPTION]: "Transcription",
};
